export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz konto oferenta"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto oferenta"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}